<template>
  <div class="flow-flex-center jFlow">
    <div class="wrap">

      <div class="bullet-center fl-right">
        <router-link
          to="/flows">
          <i class="fa fa-times"/>
        </router-link>
      </div>

      <div class="bullet-center">
        <h2>Create Flow</h2>
      </div>

      <div class="bullet-center">
        <div class="flow-new__bullet-top">
          <i class="fa fa-square"/>
        </div>
      </div>

      <div class="bullet-center">
        <div class="line-empty"/>
      </div>

      <!-- Flow of Approver -->
      <div
        v-for="(approver, index) in flow"
        :key="index"
        class="approver-order">
        <div
          v-if="index > 0"
          class="bullet-center">
          <div class="line-empty half-line"/>
        </div>
        <div class="header-flow">
          <div class="header-actions">
            <i
              class="fa fa-edit"
              @click="editFlow(index)"/>
            <i
              class="fa fa-times"
              @click="removeFlow(index)"/>
          </div>
          Approver {{ approver.order }}
        </div>
        <div class="content-flow">
          {{ approver.organigram_name ? approver.organigram_name.name : "" }} <br>
          {{ approver.organigram_name ?
            // eslint-disable-next-line max-len
            (approver.organigram_name.user ? `${approver.organigram_name.user.profile.first_name} ${approver.organigram_name.user.profile.last_name}` : "")
          : "" }}
        </div>
      </div>

      <div class="bullet-center">
        <div class="line-empty half-line"/>
      </div>

      <div class="bullet-center add-approver-flow">
        <b-btn
          class="btn blue outline"
          @click="openAddApproverForm">
          ADD APPROVER
        </b-btn>

        <!-- Modal appearance for add approver -->
        <b-modal
          ref="flowApprover"
          class="mod-form"
          centered
          no-close-on-backdrop
          no-close-on-esc>

          <!-- close button modal -->
          <div
            v-if="!edit_approver.status"
            class="close-modal-flow"
            @click="closeAddApprover">
            <i class="fa fa-times"/>
          </div>

          <!-- close for edit -->
          <div
            v-else
            class="close-modal-flow"
            @click="closeEdit">
            <i class="fa fa-times"/>
          </div>

          <!-- title modal -->
          <div
            v-if="edit_approver.status"
            class="title-flow">
            <i class="fa fa-square"/>
            Edit Approver
          </div>
          <div
            v-else
            class="title-flow">
            <i class="fa fa-square"/>
            Add Approver
          </div>

          <!-- Select division -->
          <b-form-radio-group v-model="selected">
            <b-form-radio
              value="true"
              name="Radios"
              class="jFormGroup">
              Select Division*
            </b-form-radio>
          </b-form-radio-group>
          <b-form-group :class="{'error-input' : $v.v_addApprover.organigram_id.$error}">
            <j-single-select
              v-model="v_addApprover.organigram_id"
              :is-async="true"
              :load-options="loadOptionsDivision"
              :disabled="selected !== 'true'"
              value-format="object"
              label="name"
              placeholder="All Division"/>
          </b-form-group>
          <b-form-group
            v-if="selected === 'true'"
            :class="{'error-input' : $v.v_addApprover.organigram_name.$error}">
            <label>Select Position*</label>
            <j-single-select
              v-model="v_addApprover.organigram_name"
              :is-async="true"
              :load-options="loadOptionsPositionByDivision"
              :disabled="!v_addApprover.organigram_id"
              value-format="object"
              label="name"
              placeholder="Select Position"/>
          </b-form-group>

          <!-- add division -->
          <div v-if="!edit_approver.status">
            <b-form-radio-group
              v-model="selected">
              <b-form-radio
                value="false"
                name="Radios"
                class="jFormGroup">
                Add Division*
              </b-form-radio>
            </b-form-radio-group>
            <b-form-group
              :class="{'error-input' : $v.v_addDivision.division.$error}">
              <j-input
                v-model="v_addDivision.division"
                :disabled="selected === 'true'"
                :max-length="255"
                placeholder="Add New Division"/>
            </b-form-group>
            <b-form-group
              v-if="selected !== 'true'"
              :class="{'error-input' : $v.v_addDivision.division_code.$error}">
              <label>Division Code*</label>
              <j-input
                v-model="v_addDivision.division_code"
                :max-length="255"
                placeholder="Division Code"/>
            </b-form-group>
            <b-form-group
              v-if="selected !== 'true'"
              :class="{'error-input' : $v.v_addDivision.title.$error}">
              <label>Add Position*</label>
              <j-input
                v-model="v_addDivision.title"
                :max-length="255"
                placeholder="Add Position"/>
            </b-form-group>
            <b-form-group
              v-if="selected !== 'true'"
              :class="{'error-input' : $v.v_addDivision.title_code.$error}">
              <label>Position ID*</label>
              <j-input
                v-model="v_addDivision.title_code"
                :max-length="255"
                placeholder="Position ID"/>
            </b-form-group>
            <b-form-group
              v-if="selected !== 'true'"
              :class="{'error-input' : $v.v_addDivision.user.$error}">
              <label>Select User*</label>
              <j-single-select
                v-model="v_addDivision.user"
                :is-async="true"
                :load-options="loadOptions"
                value-format="object"
                class="v-singleselect"
                placeholder="Select User"
                label="email"/>
                <!-- <j-single-select
                :options="users_list"
                v-model="v_addDivision.user"
                value-format="object"
                label= "email"
                placeholder="Select User"/> -->
            </b-form-group>
          </div>

          <div class="wrap-button-flow">
            <b-button
              v-if="edit_approver.status"
              class="btn blue"
              @click="saveEditFlow">
              EDIT APPROVER
            </b-button>
            <b-button
              v-else
              class="btn blue"
              @click="setApprover">
              SET APPROVER
            </b-button>
            <b-button
              v-if="!edit_approver.status"
              class="btn blue outline"
              @click="clearSelectedApprover">
              CLEAR
            </b-button>
          </div>

        </b-modal>
      </div>

      <!-- button for create Flow -->
      <div
        class="bullet-center">
        <b-button
          v-if="flow[0]"
          class="btn blue"
          @click="$refs.saveFlow.show()">CREATE</b-button>
      </div>

      <!-- Modal appearance for Save Flow -->
      <b-modal
        ref="saveFlow"
        class="mod-form save-flow-approver"
        no-close-on-backdrop
        no-close-on-esc
        centered>

        <!-- close button modal -->
        <div
          class="close-modal-flow"
          @click="$refs.saveFlow.hide()">
          <i class="fa fa-times"/>
        </div>

        <!-- title modal -->
        <div class="title-flow">
          <i class="fa fa-square"/>
          Save Flow
        </div>

        <b-form-group :class="{'error-input' : $v.v_saveFlow.name.$error}">
          <label>Flow Name*</label>
          <j-input
            v-model="v_saveFlow.name"
            :max-length="50"
            placeholder="ex: Flow-01"/>
        </b-form-group>

        <b-form-group :class="{'error-input' : $v.v_saveFlow.type.$error}">
          <label>Flow Type*</label>
          <j-single-select
            :options="flow_types"
            v-model="v_saveFlow.type"
            value-format="object"
            label="name"
            placeholder="Flow Type"/>
        </b-form-group>

        <div class="wrap-button-flow">
          <b-button
            class="btn blue"
            @click="saveFlow">
            SAVE
          </b-button>
        </div>

      </b-modal>

    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import { required } from 'vuelidate/lib/validators';
// eslint-disable-next-line
import { ASYNC_SEARCH } from '@riophae/vue-treeselect';
import apiUser from '@/services/jApiUser';
import jMixPaginationOption from '@/mixins/components/global/jMixPaginationOption';

const flowTypes = [
  {
    id: 1,
    type: 1,
    name: 'Order',
    minimum_action: 0,
  },
  {
    id: 2,
    type: 2,
    name: 'No Order',
    minimum_action: 0,
  },
  {
    id: 3,
    type: 3,
    name: 'Minimum 1',
    minimum_action: 1,
  },
  {
    id: 4,
    type: 3,
    name: 'Minimum 2',
    minimum_action: 2,
  },
  {
    id: 5,
    type: 3,
    name: 'Minimum 3',
    minimum_action: 3,
  },
];

export default {
  mixins: [
    jMixPaginationOption,
  ],
  data() {
    return {
      edit_approver: {
        status: false,
        current_edit: null,
      },
      selected: 'true',
      flow_type: flowTypes,
      v_addApprover: {
        organigram_id: null,
        organigram_name: null,
        order: 1,
      },
      v_addDivision: {
        division: null,
        division_code: null,
        title: null,
        title_code: null,
        user: null,
      },
      v_saveFlow: {
        name: null,
        type: null,
      },
      oldEditData: [],
      flow: [],
    };
  },
  validations: {
    v_addApprover: {
      organigram_id: { required },
      organigram_name: { required },
    },
    v_addDivision: {
      division: { required },
      division_code: { required },
      title: { required },
      title_code: { required },
      user: { required },
    },
    v_saveFlow: {
      name: { required },
      type: { required },
    },
  },
  computed: {
    ...mapState('jStoreFlows', ['users_list', 'divisions_list', 'by_divisions_list', 'new_division']),
    flow_types() {
      if (this.flow.length === 1) {
        return flowTypes.slice(0, 2);
      } else if (this.flow.length === 2) {
        return flowTypes.slice(0, 3);
      } else if (this.flow.length === 3) {
        return flowTypes.slice(0, 4);
      }
      return flowTypes;
    },
    add_approver() {
      return {
        organigram_id: this.v_addApprover.organigram_id,
        order: this.v_addApprover.order,
        organigram_name: this.v_addApprover.organigram_name,
      };
    },
    save_approver_flow() {
      return this.flow.map(prop => ({
        organigram_id: prop.organigram_name.id,
        order: prop.order,
      }));
    },
    edit_approver_flow() {
      const indexing = this.edit_approver.current_edit;
      return {
        organigram_id: this.flow[indexing].organigram_id,
        order: this.flow[indexing].order,
        organigram_name: this.flow[indexing].organigram_name,
      };
    },
    save_flow() {
      return {
        name: this.v_saveFlow.name,
        type: this.v_saveFlow.type.type,
        minimum_action: this.v_saveFlow.type.minimum_action,
        members: this.save_approver_flow,
      };
    },
    add_Division() {
      return {
        division: {
          name: this.v_addDivision.division,
          code: this.v_addDivision.division_code,
          description: '',
        },
        organigram: {
          user_company_id: this.v_addDivision.user.id,
          name: this.v_addDivision.title,
          description: '',
          code: this.v_addDivision.title_code,
          divisions: [],
        },
      };
    },
  },
  watch: {
    flow() {
      this.flow.forEach((data, index) => {
        const indexorder = index + 1;
        if (data.order !== indexorder) {
          this.flow[index].order = indexorder;
        }
      });
    },
    selected() {
      this.clearSelectedApprover();
      this.$v.v_addApprover.$reset();
      this.$v.v_addDivision.$reset();
    },
    // watch division and get detail of title each division
    /* eslint func-names: ["error", "never"] */
    // 'v_addApprover.organigram_id': function (newData) {
    //   if (this.v_addApprover.organigram_id) {
    //     const reqData = {
    //       division_id: newData.id,
    //     };
    //     this.getListByDivisions(reqData);
    //   }
    // },
    by_divisions_list(newVal) {
      if (this.v_addApprover.organigram_name) {
        const filterId = newVal.filter(idOrg => idOrg.id === this.v_addApprover.organigram_name.id);
        if (filterId.length < 0) {
          this.v_addApprover.organigram_name = null;
        }
      }
    },
    new_division(val) {
      const addApprover = {
        organigram_id: val.divisions[0],
        order: this.v_addApprover.order,
        organigram_name: val,
      };
      this.flow.push(addApprover);
      this.v_addApprover.order += 1;
      this.toggleLoading();
      this.getListDivisions();
      this.selected = 'true';
    },
  },
  created() {
    // this.getListDivisions();
  },
  methods: {
    ...mapActions('jStoreFlows', ['getListDivisions', 'getListByDivisions', 'createDivisionInFlow', 'createNewFlow']),
    ...mapActions('jStoreNotificationScreen', ['toggleLoading']),

    // open form add approver
    openAddApproverForm() {
      this.$refs.flowApprover.show();
      this.$v.v_addApprover.$reset();
      this.$v.v_addDivision.$reset();
    },

    // clear selected approver input
    clearSelectedApprover() {
      this.v_addApprover.organigram_id = null;
      this.v_addApprover.organigram_name = null;
      this.v_addDivision.division = null;
      this.v_addDivision.title = null;
      this.v_addDivision.user = null;
    },

    // set approver in order
    setApprover() {
      if (this.selected === 'true') {
        this.$v.v_addApprover.$touch();
        if (!this.$v.v_addApprover.$error) {
          this.flow.push(this.add_approver);
          this.$refs.flowApprover.hide();
          this.clearSelectedApprover();
          this.v_addApprover.order += 1;
        }
      } else {
        this.$v.v_addDivision.$touch();
        if (!this.$v.v_addDivision.$error) {
          this.createDivisionInFlow(this.add_Division);
          this.$refs.flowApprover.hide();
          this.clearSelectedApprover();
        }
      }
    },

    // remove flow order
    removeFlow(data) {
      this.flow.splice(data, 1);
    },

    // edit selected flow
    editFlow(data) {
      this.edit_approver.status = true;
      this.edit_approver.current_edit = data;
      this.$refs.flowApprover.show();
      this.v_addApprover.organigram_id = this.flow[data].organigram_id;
      this.v_addApprover.organigram_name = this.flow[data].organigram_name;
      this.v_addApprover.order = this.flow[data].order;
      this.selected = 'true';
    },

    // save new edit flow
    saveEditFlow() {
      this.$v.v_addApprover.$touch();
      if (!this.$v.v_addApprover.$error) {
        // console.log('failll');
        const currentEdit = this.edit_approver.current_edit;
        // this.flow[currentEdit] = this.add_approver;
        this.flow[currentEdit].organigram_id = this.v_addApprover.organigram_id;
        this.flow[currentEdit].organigram_name = this.v_addApprover.organigram_name;
        this.flow[currentEdit].order = this.v_addApprover.order;
        this.$refs.flowApprover.hide();
        this.clearSelectedApprover();
        this.edit_approver.status = false;
        // if (this.oldEditData[0]) {
        //   this.oldEditData.splice(0, 1);
        // }
      }
    },

    // prevent reactivity
    closeEdit() {
      this.edit_approver.status = false;
      // this.flow.splice(this.edit_approver.current_edit, 1, this.oldEditData[0]);
      this.$refs.flowApprover.hide();
      this.clearSelectedApprover();
      // this.oldEditData[0] = null;
      // this.oldEditData.splice(0, 1);
    },

    // close add approver form and get default
    closeAddApprover() {
      this.$refs.flowApprover.hide();
      this.clearSelectedApprover();
      this.selected = 'true';
    },

    // save flows and create
    saveFlow() {
      this.$v.v_saveFlow.$touch();
      if (!this.$v.v_saveFlow.$error) {
        this.createNewFlow(this.save_flow);
      }
    },

    // loadOptionsDivision({ action, searchQuery, callback }) {
    //   if (action === ASYNC_SEARCH) {
    //     const reqData = {
    //       pagination: {
    //         limit: 50,
    //         page: 1,
    //         column: '',
    //         ascending: true,
    //         query: searchQuery,
    //       },
    //     };
    //     this.getListDivisions({ reqData, callback });
    //   }
    // },

    loadOptions({ action, searchQuery, callback }) {
      if (action === ASYNC_SEARCH) {
        const reqData = {
          pagination: {
            limit: 50,
            page: 1,
            column: '',
            ascending: true,
            query: searchQuery,
            query_type: 'email',
          },
        };
        this.getListUsers(reqData, callback);
      }
    },

    async getListUsers(req, callback) {
      let apiUserData;

      if (req.pagination.query.length >= 3) {
        apiUserData = await apiUser.listUser(req);
      } else {
        apiUserData = [];
      }

      if (typeof apiUserData !== 'undefined') {
        apiUserData.forEach((lab, index) => {
          apiUserData[index].label = lab.email;
        });
      }
      callback(null, apiUserData);
      return apiUserData;
    },

  },
};
</script>

<style lang="scss">
// this style
.jFlow.flow-flex-center .save-flow-approver .b-form-group {
  padding-left: 0px;
}

.jFormGroup.form-control:disabled {
  cursor: not-allowed;
}

input.form-control::placeholder {
  opacity: 0.5;
}

</style>



// WEBPACK FOOTER //
// src/views/flow-rule/flow/jFlowNew.vue